import { useSearchParams } from "react-router-dom";
import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"
import { useState } from "react";

export const UtmostGoodFaith = () => {

    const [ReadMoreText, setReadMoreText] = useState(false)

    const handleReadmore = () => {
        setReadMoreText(!ReadMoreText)
    }

    return (
        <>
         <div className="container-fluid">
            <div className="row pb-5" >
                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold green">Utmost Good Faith </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>

                <div className="col-12 px-lg-5 ">
                    <div className="px-2" style={{ textAlign: 'justify', }}>
                        <p>By peculiar nature of the Insurance Contract, the Insurer (Insurance Company) does not have the same level of knowledge about the subject matter to be insured as the Proposer (person/company who wants to take out the insurance) has and hence the proposer should disclose all the material facts about the subject matter to the Insurer. Not only the material facts he knows but also the material facts which he ought to know about the subject matter. </p>

                        <p> A <b>material fact</b> is defined as a fact which could affect the judgment of prudent underwriter in deciding whether to accept the risk and if so at what rate of premium and subject to what terms and conditions.</p>

                        <p>Insurers will assess the risks related to the subject matter based on the information provided by the proposer and decides the rating i.e. premium to be charged and terms & Conditions of the insurance contract. Therefore, the term "Utmost" denotes the very high standard of good faith that the contracting parties are expected to uphold.  </p>

                        <p>Both the parties to insurance contract must observed the Duty of Utmost Good faith as it is a reciprocal duty. Duty of disclosure and Representation emanates from duty of Utmost Good Faith.  </p>
                    </div>
                </div>

                <div className="col-12 p-lg-5 pt-5" >
                    <div className="p-lg-5 p-4 bgservices " style={{ position: 'relative', textAlign: 'justify', }}>
                    <h5 className="fw-bold pb-3">Case Law: </h5>
                        <p>
                            <b> Carter v Boehm (1766) </b>
                            is the landmark English court case which establish the duty of utmost good faith.
                        </p>

                        <p>
                            <b> Facts of the case: </b>
                            Roger Carter (1723-74), the plaintiff was the then Deputy Governor of the East India Company’s factory at Fort Marlborough. Britain and France had been at war and Carter had already experienced armed conflict and maritime blockades.

                        </p>






                        {ReadMoreText && (
                            <div>
                                <p>Carter asked his brother in London to take out insurance policy on his behalf against the risk of a European enemy attack on Fort Marlborough. The policy was issued by the defendant underwriter, Charles Boehm in London on 9th May 1760 for Sum Insured Pound 10,000 @ 4% premium. Policy was issued covering occurrence of an event- an enemy attack, on the terms- “interest or no interest”, “Free from average” and “without benefit of salvage”.
                                    On 31st March 1760, there was opportunistic attack on the Fort Marlborough by D’Estaing. Roger Carter along with the Company’s servants at Fort Marlborough surrendered.</p>
                                <p>
                                    Carter’s claim under policy was resisted by the underwriters on the grounds of non-disclosure and argued that the insurer has right to know as much as the insured himself know and which increases the risk accepted by underwriters.
                                </p>
                                <p>
                                    It was argued by the Counsel that the facts were Universally known to every merchant upon the exchange of London. The insured need not mention what the underwriter knows or ought to know.
                                </p>

                                <p>
                                    Underwriters were knowing that Carter was well acquainted with the state
                                    of Fort Marlborough, knowing that he apprehended danger, had signed the policy without question/inquiry.
                                </p>

                                <p>
                                    The attack on the Fort Marlborough by D’Estaing was an opportunistic and Carter had no knowledge of any attack plan existing in September 1759.
                                    Finally, Mansfield asserted that if Boehm’s objections to Carter’s claim were to prevail, the disclosure rule, which was designed to prevent fraud and encourage good faith, could be turned perversely into an instrument of fraud in the hands of the insurer.
                                </p>

                                <p>
                                    ‘Insurance is a contract upon speculation’, characterized by an asymmetry of information. ‘Good faith forbids either party by concealing what he privately knows, to draw the other into a bargain, from his ignorance of that fact, and his believing the contrary’.
                                </p>
                            </div>

                        )}

                        <p className="float-end read_more_btn pb-lg-3">
                            <button className="btn button" onClick={handleReadmore}>
                                <span>{ReadMoreText ? 'Read Less' : 'Read More'}</span>
                            </button>
                        </p>







                    </div>
                </div>

                <div className="col-12 mt-5  mt-lg-0 px-lg-5 ">
                    <div className=" food_for_health">

                        <div className="row ps-lg-5 pt-lg-5 pb-lg-3">
                            <div className="col-12 col-lg-8 p-5 p-lg-0" style={{ textAlign: 'justify', }}>
                                <p><b> Food for Thought:  </b></p>

                                <p> Insurance Act 2015, has amended the Section 17 (Insurance is Uberrimae Fidei), Section 18 (Disclosure by Assured) and Section 20 (Representations Pending Negotiation of Contract) of Marine Insurance Act 1906 and imposed the “Duty of Fair Presentation of Risk” on the proposer.
                                </p>

                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>	 Does  this English Law amendments will have any effect of the Marine insurance policies issued by the Indian underwriters? </p>
                            </div>
                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />

                            </div>
                        </div>


                    </div>
                </div>
            </div>
            </div>
            {/* <Footer />
                </div>
            </div> */}
        </>
    )
}
